<!-- 首营商品审核任务 -->
<template>
    <div class='page_content'>
        <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
            <firstGoodsAction v-if="showStatus" ref="firstGoodsAction" @drawerCancel="drawerCancel" :actionData="actionData"></firstGoodsAction>
        </el-drawer>
        <subComponents ref="showSelectData"></subComponents>

        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearchs="openSearch">
                    <template slot="searchInput" slot-scope="{formOneValue}">
                        <el-input v-if="formOneValue.entityField == 'bgmId'" clearable @focus="$refs['showSelectData'].openBox('businessGoodsList', 'bgmId', 'bgmId')" v-model="getRequestData.bgmName" :maxlength="$store.state.inputLength">
                        </el-input>
                    </template>
                </v-search>
            </div>
        </div>
        <div class="page_content_center">
            <div class="left" :style="{height: tableHeight+'px'}" v-if="isMenu">
                <el-menu :default-active="activeMenu" :key="'menu-' + menuList.length" class="el-menu-vertical-demo" @select="handleMenuSelect">
                    <el-menu-item index="all">
                        <i class="el-icon-menu"></i>
                        <span slot="title">全部</span>
                    </el-menu-item>
                    <el-menu-item v-for="item in menuList" :key="item.codeId" :index="String(item.codeId)">
                        <i class="el-icon-document"></i>
                        <span slot="title">{{ item.codeType }}</span>
                    </el-menu-item>
                </el-menu>
            </div>
            <div class="right" :class="{ 'right-full': !isMenu }">
                <el-table size="mini" :row-class-name="rowClassName" v-if="pageShowData.jurTableVo" @selection-change="mainSelectionChange" :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border @sort-change="sortChange" style="width: 100%"
                    highlight-current-row>
                    <el-table-column type="selection" width="50"></el-table-column>
                    <template v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable">
                        <el-table-column align="center" v-if="tableValye.isShow == 1" :sortable="tableValye.isSort == 1 ? 'custom' : false" show-overflow-tooltip :min-width="tableValye.fieldWeight" :key="tableKey" :prop="tableValye.entityField"
                            :label="tableValye.showField">
                            <template slot-scope="scope">
                                <span v-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                </span>
                                <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.entityField]">
                                    {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                                </span>
                                <span v-else-if="tableValye.isRift == 1">
                                    <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField] }}</a>
                                </span>
                                <span v-else-if="tableValye.entityField == 'bgmActivestatus'">
                                    {{ $store.state.businessGoodsState[scope.row.bgmActivestatus].name }}
                                </span>
                                <el-tag size="mini" v-else-if="tableValye.entityField == 'ggmState'">
                                    {{ $common.getIsGsp(tableValye.formatterContent, scope.row.ggmState) }}</el-tag>
                                <el-tag size="mini" v-else-if="tableValye.fieldType == 'formatter'">
                                    {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</el-tag>
                                <span v-else>
                                    {{ scope.row[tableValye.entityField] }}
                                </span>
                            </template>
                        </el-table-column>
                    </template>
                </el-table>
            </div>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
            <SearchScheme ref="searchScheme" :id="seId" :smId="cmId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
        <printPlan ref="printPlan"></printPlan>

    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import firstGoodsAction from "@/components/firstGoodsAction.vue";

export default {
    //import引入的组件需要注入到对象中才能使用
    components: { firstGoodsAction },
    data() {
        //这里存放数据
        return {
            selectVal: [],
            tableHeight: 0,
            getRequestData: {
                bgmId: "",
                bgmName: "",
                stName: "",
                page: 1,
                rows: 30,
                start:
                    new Date(new Date().toLocaleDateString()).getTime() -
                    31 * 24 * 3600 * 1000,
                end:
                    new Date(new Date().toLocaleDateString()).getTime() +
                    24 * 60 * 60 * 1000 -
                    1,
            },
            returnData: {
                pages: 0, // 总页数
                total: 0, // 总条数
                pageNum: 0, // 当前页数
                list: [],
            },
            buttonList: [],
            pageShowData: [],
            formDataList: [],
            showStatus: false,
            actionData: [],
            requesUrl: "",
            ormId: "",
            DialogVisible: false,
            seId: "",
            sField: "",
            cmId: "",
            parentSearchData: {},
            seWidth: 0,
            seTitle: "",
            menuList: [],
            activeMenu: "all",
            isMenu: false,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "getRequestData.bgmName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.bgmId = "";
                }
            },
            deep: true,
        },
        "getRequestData.stName": {
            handler: function (newValue, oldValue) {
                if (newValue == "") {
                    this.getRequestData.stId = "";
                }
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        // 表格方法
        rowClassName({ row, rowIndex }) {
            let rowName = ""
            if (row.focuson == 1) {
                rowName = "danger-row"; // 可以通过此处给选中行一个class，给自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },
        sortChange(column) {
            this.returnData.list = this.$common.sortChange(column, this.returnData.list, this.pageShowData.jurTableVo.jurconfigtable, 'entityField')
        },
        mainSelectionChange(val) {
            this.selectVal = val;
        },
        getSeWidth(e) {
            // console.log(e);
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            // console.log(e);
            this.seTitle = e;
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.DialogVisible = true;
            this.seId = sId;
            this.sField = sField;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        //检索带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val);
            }
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.getRequestData[item] = val[item];
            });
        },
        // 子组件触发
        drawerCancel(commitData) {
            this.showStatus = false;
            commitData && this.getDataList();
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页
                var isPenetrate = true;
                // 设置缓存 存入点击单号
                this.resetSetItem("penetrateOrderId", orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage(
                    {
                        //向窗口发送MessageEvent消息
                        cmd: "returnFormJson",
                        params: {
                            isPenetrate,
                        }, //参数
                    },
                    "*"
                );
            }
        },
        isShowData(name, value) {
            switch (name) {
                case "bgmId":
                    var dataInfo = sessionStorage.getItem(
                        "selectBusinessGoodsEntryInfo"
                    );
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.getRequestData.bgmId = dataInfo.bgmId;
                        this.getRequestData.bgmName = dataInfo.bgmName;
                    }

                    break;

                default:
                    this.getRequestData[name] = value;
            }
        },
        getPageInfo() {
            var ss = parent.getMenuInfo(this.$route.path);
            this.getDataTest(ss.jurId);
        },
        
        // 获取数据列表
        async getDataTest(ids) {
            let responseData = await this.$http.getJur({
                ids: [ids],
            });
            if (responseData.status == 200) {
                this.getButtonList();
                this.pageShowData = responseData.result;
                this.formDataList = this.pageShowData.jurFormVoList;
                var obj = {};
                this.formDataList.forEach((item) => {
                    if (item.jciId == 11190) {
                        //首营商品表单
                        item.jciId = 11145;
                    } else if (item.jciId == 11427) {
                        //证照
                        item.jciId = 11405;
                    }
                });
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(
                        this.pageShowData.jurHead.jurconfigform,
                        "page",
                        "rows",
                        30
                    );
                } else {
                    obj = this.$common.getSearch(
                        this.getRequestData,
                        "start",
                        "end",
                        "page",
                        "rows",
                        30
                    );
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key]);
                }
                await this.getMenuData();
                this.getDataList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 左侧菜单切换
        handleMenuSelect(codeId) {
            this.activeMenu = String(codeId)
            if (codeId === 'all') {
                this.$set(this.getRequestData, 'codeType', '')
            } else {
                const menuItem = this.menuList.find(item => String(item.codeId) === String(codeId))
                if (!menuItem) return
                this.$set(this.getRequestData, 'codeType', menuItem.codeType)
            }
            this.getRequestData.page = 1
            this.getDataList()
        },

        // 动作集合
        async actionSet(actionData) {
            console.log(actionData.actionType)
            if (actionData.actionType != 15 && actionData.actionType != 6 && actionData.actionType != 7 && actionData.actionType != 8 && actionData.actionType != 12) {
                if (this.returnData.list.length <= 0) {
                    this.$message({
                        message: "暂无数据",
                        type: "error",
                    });
                    return false;
                }
                if (this.selectVal.length == 0) {
                    this.$message({
                        message: "请先选择您要操作的数据",
                        type: "error",
                    });
                    return false;
                }
                var dataInfo;
                const result = await this.$http.queryFirstGoodsInfo({
                    ids: [this.selectVal[0].ggmId],
                });
                if (result.status == 200) {
                    dataInfo = result.result;
                } else {
                    return this.$message.error(result.message);
                }
            }

            switch (actionData.actionType) {
                case 4:
                    this.formDataList = [];
                    if (dataInfo.goodType == 0) {//药品
                        console.log("药品", this.pageShowData)
                        this.pageShowData.jurFormVoList && this.pageShowData.jurFormVoList.forEach((v) => {
                            if (!/(器|其他)/g.test(v.jciName)) this.formDataList.push(v);
                        });
                    } else if (dataInfo.goodType == 1) {//器械
                        console.log("器械", this.pageShowData)
                        this.pageShowData.jurFormVoList && this.pageShowData.jurFormVoList.forEach((v) => {
                            if (!/(商品|其他)/g.test(v.jciName)) this.formDataList.push(v);
                        });
                    } else if (dataInfo.goodType == 2) {//其他
                        console.log("其他", this.pageShowData)
                        this.pageShowData.jurFormVoList && this.pageShowData.jurFormVoList.forEach((v) => {
                            if (!/(商品|器)/g.test(v.jciName)) this.formDataList.push(v);
                        });
                    }
                    this.showStatus = true;
                    this.actionData = {
                        cate: actionData.actionType,
                        formData: this.formDataList,
                        oldData: dataInfo,
                        orderId: dataInfo.ggmId,
                        printSouce: "",
                        printJurId: "",
                        fatherType: false,
                    };
                    break;
                case 5:
                    this.formDataList = [];
                    if (dataInfo.goodType == 0) {//药品
                        console.log("药品", this.pageShowData)
                        this.pageShowData.jurFormVoList && this.pageShowData.jurFormVoList.forEach((v) => {
                            if (!/(器|其他)/g.test(v.jciName)) this.formDataList.push(v);
                        });
                    } else if (dataInfo.goodType == 1) {//器械
                        console.log("器械", this.pageShowData)
                        this.pageShowData.jurFormVoList && this.pageShowData.jurFormVoList.forEach((v) => {
                            if (!/(商品|其他)/g.test(v.jciName)) this.formDataList.push(v);
                        });
                    } else if (dataInfo.goodType == 2) {//其他
                        console.log("其他", this.pageShowData)
                        this.pageShowData.jurFormVoList && this.pageShowData.jurFormVoList.forEach((v) => {
                            if (!/(商品|器)/g.test(v.jciName)) this.formDataList.push(v);
                        });
                    }
                    this.showStatus = true;
                    this.actionData = {
                        cate: actionData.actionType,
                        formData: this.formDataList,
                        oldData: dataInfo,
                        orderId: dataInfo.ggmId,
                        printSouce: "",
                        printJurId: "",
                        fatherType: false,
                    };
                    break;
                case 6:
                    this.exportMainInfo();
                    break;
                case 7:
                    this.exportLicenceInfo();
                    break;
                case 8:
                    this.exportApparatus();
                    break;
                case 9:
                    this.openDataActionBox(dataInfo);
                    break;
                case 15:
                    this.openFormDesign();
                    break;
                case 11:
                    this.backDataAction();
                    break;
                case 12:
                    this.exportAll();
                    break;
                case 99:
                    console.log(actionData);
                    if (this.selectVal.length < 1) {
                        this.$message({
                            message: "至少选中一条数据打印！",
                            type: "error",
                        });
                        return false;
                    }
                    this.showPrintPlan();
                    break;
            }
        },
        // 导出商品资料数据
        exportAll() {
            window.location.href =
                this.requesUrl +
                `/GSPgoods/exportGoodsData?ormId=${sessionStorage.getItem("ormId")}`;
        },
        // 回退
        async backDataAction() {
            if (this.selectVal.length != 1) {
                this.$message({
                    message: '请先选择您要操作的一条数据',
                    type: 'error'
                });
                return false
            }
            var dataInfo = this.selectVal[0]
            if (dataInfo.ggmState != 1) {
                return this.$message.error('该状态不能回退')
            }
            var delData = {
                ids: [dataInfo.ggmId]
            }
            let responseData = await this.$http.getFirstGoodsGoBack(delData)
            if (responseData.status == 200) {
                this.$message({
                    type: 'success',
                    message: '退回成功!'
                });
                this.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }

        },
        showPrintPlan() {
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                var list = this.selectVal.map((item) => item.ggmId);
                // 1
                this.$refs.printPlan.openDia(list, 'printData/pisGoods', '1608259974606', "", "all");
            } else {
                return;
            }
        },
        async openDataActionBox(dataInfo) {
            let dataList;
            let responseData = await this.$http.getJur({
                ids: [1614737096791],
            });
            if (responseData.status == 200) {
                dataList = responseData.result.jurFormVoList;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
            if (this.returnData.list.length <= 0) {
                this.$message({
                    message: "暂无数据",
                    type: "error",
                });
                return false;
            }
            if (this.selectVal.length == 0) {
                this.$message({
                    message: "请先选择您要操作的数据",
                    type: "error",
                });
                return false;
            }
            var olddataInfo = dataInfo
            let passList = [];
            if (olddataInfo.goodType == 0) {//药品
                console.log("药品", dataList)
                dataList && dataList.forEach((v) => {
                    if (!/(器|其他)/g.test(v.jciName)) passList.push(v);
                });
            } else if (olddataInfo.goodType == 1) {//器械
                console.log("器械", dataList)
                dataList && dataList.forEach((v) => {
                    if (!/(商品|其他)/g.test(v.jciName)) passList.push(v);
                });
            } else if (olddataInfo.goodType == 2) {//其他
                console.log("其他", dataList)
                dataList && dataList.forEach((v) => {
                    if (!/(商品|器)/g.test(v.jciName)) passList.push(v);
                });
            }
            this.actionData = {
                cate: 9,
                formData: passList,
                oldData: olddataInfo,
                orderId: olddataInfo.ggmId,
                printSouce: "",
                printJurId: "",
                fatherType: false,
            };
            this.showStatus = true;
        },

        // 导出商品资料数据
        exportMainInfo() {
            this.getDataList()
            if (this.returnData.list.length == 0) {
                this.$message.warning("暂无数据可以导出！")
                return
            }
            this.getRequestData.ormId = sessionStorage.getItem("ormId");
            window.location.href =
                this.requesUrl +
                `/GSPgoods/exportGoodsData${this.$common.getUrl(
                    this.getRequestData
                )}`;
        },

        // 导出器械主信息
        exportApparatus() {
            this.getDataList()
            if (this.returnData.list.length == 0) {
                this.$message.warning("暂无数据可以导出！")
                return
            }
            this.getRequestData.ormId = sessionStorage.getItem("ormId");
            var flag = false;
            this.returnData.list.forEach((item) => {
                if (item.goodType == 1) {
                    flag = true;
                }
            });
            if (!flag) {
                return this.$message.error("暂无器械商品数据");
            }
            window.location.href =
                this.requesUrl +
                `/GSPgoods/exportQxGoodsData${this.$common.getUrl(
                    this.getRequestData
                )}`;
        },
        // 导出商品证照资料数据
        exportLicenceInfo() {
            this.getDataList()
            if (this.returnData.list.length == 0) {
                this.$message.warning("暂无数据可以导出！")
                return
            }
            this.getRequestData.ormId = sessionStorage.getItem("ormId");
            window.location.href =
                this.requesUrl +
                `/GSPgoods/exportGoodLicenceData${this.$common.getUrl(
                    this.getRequestData
                )}`;
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path);
            this.$refs["customDesign"].openBox(
                pathInfo.jurId,
                this.pageShowData,
                pathInfo.jurName
            );
        },

        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData = await this.$http.getFirstGoodsHistory(
                this.getRequestData
            );
            if (responseData.status == 200) {
                this.returnData.list = responseData.result.list;
                this.returnData.pages = responseData.result.pages;
                this.returnData.total = responseData.result.total;
                this.returnData.pageNum = responseData.result.pageNum;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        async getMenuData() {
            const params = { codeClassify: 0 }
            const res = await this.$http.getQueryCodeClassify(params)
            if (res.status == 200) {
                this.menuList = res.result || []
            } else {
                this.menuList = []
            }
            this.activeMenu = "all"
            this.$set(this.getRequestData, 'codeType', '')
        },

        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton();
            
        },
},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.requesUrl = this.$store.getters.getConfig.requestUrl;
        this.ormId = sessionStorage.getItem("ormId");
        this.getPageInfo();
        this.isMenu = window.global_config.isLeftMenuBgm || false
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.tableHeight = this.$common.getTableHeight();
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.page_content_center {
    display: flex;
    justify-content: space-between;
}

.left {
    flex-shrink: 0;
    overflow-y:auto;
    overflow-x: hidden;
    width: 150px;
}

.el-menu-vertical-demo {
    width: 150px;
    border-right: none;
}

.right {
    flex: 1;
    min-width: 0;
    width: calc(100% - 160px);
}

.right-full {
    width: 100%;
}

::v-deep .el-menu-item {
    height: 36px;
    line-height: 36px;
}
</style>